webpackJsonp([1],{

/***/ "+8bK":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("J2ZD"),
  /* template */
  __webpack_require__("gzg6"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "+yxU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/remark-market.d54d0b8.png";

/***/ }),

/***/ "/E17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export datas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return priceOptionDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscription; });
var datas = [['苹果', 'AAPL'], ['谷歌A', 'GOOGL'], ['谷歌C', 'GOOG'], ['微软', 'MSFT'], ['亚马逊', 'AMZN'], ['脸书', 'FB'], ['强生', 'JNJ'], ['摩根大通', 'JPM'], ['埃克森美孚', 'XOM'], ['沃尔玛', 'WMT'], ['美国银行', 'BAC'], ['富国银行', 'WFC'], ['维萨卡VISA', 'V'], ['伯克希尔哈撒韦B', 'BRK.B'], ['宝洁', 'PG'], ['雪佛龙', 'CVX'], ['台积电', 'TSM'], ['英特尔', 'INTC'], ['辉瑞', 'PFE'], ['中国移动', 'CHL'], ['美国电话电报公司AT&T', 'T'], ['联合健康', 'UNH'], ['甲骨文', 'ORCL'], ['可口可乐', 'KO'], ['百事可乐', 'PEP'], ['花旗集团', 'C'], ['丰田汽车', 'TM'], ['威瑞森', 'VZ'], ['思科', 'CSCO'], ['迪士尼', 'DIS'], ['通用电气', 'GE'], ['万事达', 'MA'], ['波音', 'BA'], ['荷兰壳牌', 'RDS.A'], ['IBM', 'IBM'], ['麦当劳', 'MCD'], ['英国石油', 'BP'], ['英伟达', 'NVDA'], ['中石油', 'PTR'], ['必和必拓', 'BHP'], ['博通', 'AVGO'], ['高通', 'QCOM'], ['中国人寿', 'LFC'], ['耐克', 'NKE'], ['高盛', 'GS'], ['摩根士丹利', 'MS'], ['洛克希德马丁', 'LMT'], ['PayPal', 'PYPL'], ['Adobe', 'ADBE'], ['中石化', 'SNP'], ['斯伦贝谢', 'SLB'], ['美国运通', 'AXP'], ['力拓', 'RIO'], ['奈飞', 'NFLX'], ['星巴克', 'SBUX'], ['陶氏杜邦', 'DWDP'], ['沃达丰', 'VOD'], ['卡特彼勒', 'CAT'], ['贝莱德', 'BLK'], ['荷兰国际', 'ING'], ['时代华纳', 'TWX'], ['瑞银', 'UBS'], ['高露洁', 'CL'], ['巴西石油公司', 'PBR'], ['劳埃德银行', 'LYG'], ['通用汽车', 'GM'], ['中海油', 'CEO'], ['康菲石油', 'COP'], ['索尼', 'SNE'], ['美国国际集团', 'AIG'], ['雷神', 'RTN'], ['纽约梅隆银行', 'BK'], ['21世纪福克斯(B股)', 'FOX'], ['特斯拉', 'TSLA'], ['淡水河谷', 'VALE'], ['孟山都', 'MON'], ['雅虎（Altaba）', 'AABA'], ['Phillips 66', 'PSX'], ['动视暴雪', 'ATVI'], ['T-Mobile US', 'TMUS'], ['福特汽车', 'F'], ['保德信金融', 'PRU'], ['巴克莱银行', 'BCS'], ['eBay', 'EBAY'], ['中国电信', 'CHA'], ['旅行者保险', 'TRV'], ['德意志银行', 'DB'], ['哈利伯顿', 'HAL'], ['惠普', 'HPQ'], ['中国联通', 'CHU'], ['瓦莱罗能源', 'VLO'], ['黑石集团', 'BX'], ['达美航空', 'DAL'], ['艺电', 'EA'], ['塔吉特', 'TGT'], ['诺基亚', 'NOK'], ['穆迪', 'MCO'], ['百胜餐饮', 'YUM'], ['西部数据', 'WDC'], ['法拉利', 'RACE'], ['斯普林特', 'S'], ['富兰克林-邓普顿', 'BEN'], ['哥伦比亚广播公司', 'CBS'], ['纽蒙特矿业', 'NEM'], ['美高梅', 'MGM'], ['爱立信', 'ERIC'], ['纽柯钢铁', 'NUE'], ['赛门铁克', 'SYMC'], ['巴里克黄金', 'ABX'], ['智利矿业化工', 'SQM'], ['Twitter', 'TWTR'], ['蒂芙尼', 'TIF'], ['加拿大能源', 'ECA'], ['Cheniere Energy', 'LNG'], ['蔻驰', 'TPR'], ['中国铝业', 'ACH'], ['AMD公司', 'AMD'], ['香港恒生指数', 'HSI'], ['恒生国企指数', 'HSCEI'], ['恒生红筹指数', 'HSCCI']];

var priceOptionDatas = function () {
  var items = {};
  datas.forEach(function (item) {
    items[item[1]] = {
      name: item[0],
      bValue: null,
      pValue: null,
      dir: '',
      bgColor: '',
      textColor: '',
      bTextColor: ''
    };
  });
  return items;
}();

var subscription = function () {
  var items = [];
  datas.forEach(function (item) {
    items.push(item[1]);
  });
  return items;
}();

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "0+am":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certification@2x.b42e1c6.png";

/***/ }),

/***/ "05Kn":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("YqNy"),
  /* template */
  __webpack_require__("eMRG"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1/Qc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chengxinwangzhan.9d699b4.png";

/***/ }),

/***/ "3Jun":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cooperation.40575e9.jpg";

/***/ }),

/***/ "3SEp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-03@2x.257aed2.png";

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("D+QH");


/***/ }),

/***/ "47nT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/head-pic@2x.7678abf.png";

/***/ }),

/***/ "4AC6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/time-weekly.76c3642.png";

/***/ }),

/***/ "4R6w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-1.df1ecde.png";

/***/ }),

/***/ "4u6v":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("AwCw")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("bIbA"),
  /* template */
  __webpack_require__("h3wr"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "5+GW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-01.f531c05.png";

/***/ }),

/***/ "5FT1":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("BF/s"),
  /* template */
  __webpack_require__("6Z/C"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "6Z/C":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('jin-dialog', {
    attrs: {
      "custom-class": "ushk-remark",
      "size": "large"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [(_vm.data.type === 'image-text') ? _c('div', {
    staticClass: "ushk-remark__ctn"
  }, [_c('div', {
    staticClass: "ushk-remark__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.pic,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.data.content) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.data.type === 'content') ? [_c('div', {
    staticClass: "ushk-remark-content"
  }, [_c('i'), _vm._v(" "), _c('h3', {
    staticClass: "ushk-remark__title"
  }, [_vm._v("\n        " + _vm._s(_vm.data.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ushk-remark__text"
  }, [_vm._v("\n        " + _vm._s(_vm.data.content) + "\n      ")]), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "ushk-remark-content__info"
  }, [_vm._v("美港电讯注")])] : _vm._e(), _vm._v(" "), (_vm.data.type === 'video') ? _c('div', {
    staticClass: "ushk-remark-video"
  }, [_c('div', {
    staticClass: "ushk-remark-video__b"
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "poster": _vm.data.cover,
      "src": _vm.data.link,
      "controls": "controls",
      "preload": "none",
      "playsinline": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.data.content) + "\n    ")])]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ "7+0T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.305d335.png";

/***/ }),

/***/ "8ttZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filterTag */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dataSplicing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_kind__ = __webpack_require__("nlLt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_utils__ = __webpack_require__("j+bc");



var filterTag = function filterTag(content) {
  var tagNames = content.match(/\$(.*?)\$/g);
  var contents = [];
  if (tagNames !== null) {
    var i = 0;
    var l = tagNames.length;
    var tagName = '';
    for (; i < l; i++) {
      tagName = tagNames[i];
      if (content.indexOf('<$>' + tagName + '<$>') === -1) {
        content = content.replace(new RegExp('\\$' + tagName.replace(/(\$)/g, '').replace(/(\()/g, '（').replace(/(\))/g, '）') + '\\$', 'g'), '<$>' + tagName + ' <$>');
      }
    }
    var isBold = false;
    content = content.split(/<\$>| <\$>/);
    if (content[0].indexOf('<b>') !== -1 && content[content.length - 1].indexOf('</b>') !== -1) {
      isBold = true;
    }
    content.forEach(function (data, index) {
      if (data) {
        var isTag = data.match(/(\$)/g);
        if (index === 0 && data === '<b>') {
          return false;
        }
        contents.push({
          isTag: isTag && isTag.length === 2,
          data: data.replace(/(\$)/g, ''),
          isBold: isBold
        });
      }
    });
  }
  return contents;
};

var filterData = function filterData(data, isSocket, stockAffect) {
  var type = data.type,
      time,
      startTime,
      content,
      star = 0,
      id,
      evaluate,
      evaluateClass,
      evaluateArry = [],
      date = '',
      showDate = false,
      formatDate = '',
      pubDate = '',
      resData = data.data,
      params = {};
  data.time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_utils__["c" /* dateFormat */])(data.time, 'yyyy-MM-dd hh:mm:ss');
  if (type === 0) {
    id = data.time;
    date = id.split(' ')[0];
    time = id.split(' ')[1];
    startTime = 'T_' + id.replace(/-/g, '').replace(/:/g, '').replace(/ /g, '') + '_0';
    content = resData.content.replace(/\n/ig, '<br/>');
    if (content.indexOf('<b>') !== -1) {
      if (content.match(/<([a-z]+)(\s*\w*?\s*=\s*".+?")*(\s*?>[\s\S]*?(<\/\1>)+|\s*\/>)/i) === null) {
        content = content.replace('<b>', '');
      }
    }

    var relevances = content.replace(/<\/?[^>]*>/g, '').split('：');
    var relevance = '';
    if (relevances.length >= 2) {
      if (relevances[0].length < 20 && relevances[0] !== '据外媒') {
        relevance = relevances[0];
      }
    }
    data.data.picLite = resData.pic ? resData.pic + '?x-oss-process=image/resize,m_lfit,w_500,limit_1/auto-orient,0/quality,q_80' : '';
    data.data.content = content;
    data.relevance = relevance;
    data.curRelevance = self.curRelevance;
  } else if (type === 1 || type === 3) {
    star = resData.star;
    var affect = resData.affect;
    var actual = resData.actual;
    var previous = resData.previous;
    var consensus = resData.consensus;
    previous = previous && parseFloat(resData.previous);
    consensus = consensus && parseFloat(resData.consensus);
    var unit = resData.unit;
    var important = star > 2;
    var testUnit = /^[\u4e00-\u9fa5]+$/.test(unit);

    var _genClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_kind__["a" /* genClassName */])(resData, stockAffect),
        statusClass = _genClassName.statusClass,
        statusName = _genClassName.statusName;

    id = data.time;
    date = id.split(' ')[0];
    time = id.split(' ')[1];
    startTime = 'T_' + id.replace(/-/g, '').replace(/:/g, '').replace(/ /g, '') + '_' + star;


    content = resData.type === 1 ? '' + resData.name + resData.time_period + ' ' + resData.measure + (testUnit ? '\uFF08' + unit + '\uFF09' : '') : '' + resData.country + resData.time_period + resData.name + (testUnit ? '\uFF08' + unit + '\uFF09' : '');

    data.important = important ? 1 : 0;
    data.data.starNum = parseInt(star) * 20 + '%';
    data.data.pubDate = pubDate;
    data.data.evaluate = statusName;
    data.data.content = content;
    data.data.evaluateClass = statusClass;
    data.data.kind = '股票';
    data.data.trend = 1;
    var percent = '%';
    if (unit && !testUnit) {
      if (unit === percent) {
        unit = '';
      } else {
        percent = '';
      }
      data.data.previous = previous !== null ? unit + previous + percent : '';
      data.data.consensus = consensus !== null ? unit + consensus + percent : '';
      data.data.actual = actual !== null ? unit + actual + percent : '';
    }
  }
  data.time_view = time;
  data.startTime = startTime;
  data.remark = data.remark || null;
  if (data.remark) {
    data.remark = data.remark.filter(function (it) {
      return ['link', 'mage-text', 'video', 'market', 'content'].includes(it.type);
    });
  }
  params = data;

  if (data.data.unit === '亿立方英尺') {}
  if (type === 3) {
    return params;
  }
  formatDate = date.split('-');
  params.isSocket = isSocket;
  params.date = date;
  params.formatDate = {
    m: formatDate[1],
    d: formatDate[2]
  };
  return params;
};

var dataSplicing = function dataSplicing(datas) {
  var list = [];
  var i = 0;
  var l = datas.length;
  for (; i < l; i++) {
    var data = filterData(datas[i]);
    if (!data) {
      continue;
    } else {
      list.push(data);
    }
  }
  return list;
};

/***/ }),

/***/ "9cE2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Switch_vue__ = __webpack_require__("05Kn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Switch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Switch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FlashList_vue__ = __webpack_require__("VkxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FlashList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FlashList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Price__ = __webpack_require__("mQei");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Price___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Price__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Skeleton__ = __webpack_require__("u8M6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Skeleton__);






var components = {
  UshkSwitch: __WEBPACK_IMPORTED_MODULE_1__Switch_vue___default.a,
  FlashList: __WEBPACK_IMPORTED_MODULE_2__FlashList_vue___default.a,
  UshkPrice: __WEBPACK_IMPORTED_MODULE_3__Price___default.a,
  Skeleton: __WEBPACK_IMPORTED_MODULE_4__Skeleton___default.a
};

function install(Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).forEach(function (key) {
    Vue.component(key, components[key]);
  });
}

/***/ }),

/***/ "9eTL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-3.8d38244.png";

/***/ }),

/***/ "9hpj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/money.fb5c585.png";

/***/ }),

/***/ "AaAd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-01@2x.50f6cf8.png";

/***/ }),

/***/ "AwCw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Axr/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/money-important@2x.f940803.png";

/***/ }),

/***/ "BEao":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/star-active@2x.7cddcfe.png";

/***/ }),

/***/ "BF/s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: {
    remarkData: Object,
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: this.value,
      data: {}
    };
  },

  watch: {
    value: function value(v) {
      var _this = this;

      this.visible = v;
      if (v) {
        this.data = this.remarkData;
      } else {
        setTimeout(function () {
          _this.data = {};
        }, 200);
      }
    },
    visible: function visible(v) {
      this.$emit('input', v);
    }
  }
});

/***/ }),

/***/ "BgiE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-04.195947f.png";

/***/ }),

/***/ "D+QH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__("DfDl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules__ = __webpack_require__("9cE2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("4u6v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload__ = __webpack_require__("AXdl");









var vm = null;

var init = function init() {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3__modules__["a" /* default */]);
  window.JIN10_APP.VueComponents(__WEBPACK_IMPORTED_MODULE_0_vue___default.a);
  vm = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a },
    template: '<App/>',
    store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
    el: '#J_ushk'
  });
};

if (false) {
  window.Vue = Vue;
  addScript('//cdn.jin10.com/assets/js/vue-components/js/index.js', function () {
    init();
  });
} else {
  init();
}

/***/ }),

/***/ "DO2A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/head-pic-01@2x.7678abf.png";

/***/ }),

/***/ "DS8b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/money-active.f22f675.png";

/***/ }),

/***/ "DgEf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-03@2x.5dec1b2.png";

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_USER; });
var UPDATE_USER = 'UPDATE_USER';

/***/ }),

/***/ "Ew40":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-skeleton"
  }, [_c('div', {
    staticClass: "ushk-skeleton-list"
  }, [_c('div', {
    staticClass: "ushk-skeleton-message"
  }, [_c('div', {
    staticClass: "ushk-skeleton-h"
  }, [_c('div', {
    staticClass: "ushk-flash_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-time"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-b"
  }, [_c('div', {
    staticClass: "ushk-skeleton-message-tag"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-message-text"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-imagetext"
  }, [_c('div', {
    staticClass: "ushk-skeleton-h"
  }, [_c('div', {
    staticClass: "ushk-flash_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-time"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-b"
  }, [_c('div', {
    staticClass: "ushk-skeleton-imagetext-text"
  }, [_c('div', {
    staticClass: "ushk-skeleton-imagetext-text-inner"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-imagetext-attach"
  }, [_c('div', {
    staticClass: "ushk-skeleton-imagetext-img"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data"
  }, [_c('div', {
    staticClass: "ushk-skeleton-h"
  }, [_c('div', {
    staticClass: "ushk-flash_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-time"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-b"
  }, [_c('div', {
    staticClass: "ushk-skeleton-data-des"
  }, [_c('div', {
    staticClass: "ushk-skeleton-data-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-text"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-detail-wrap"
  }, [_c('div', {
    staticClass: "ushk-skeleton-data-vote"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-publish"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-tag"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-country"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-pubdate"
  })])])])])])
}]}

/***/ }),

/***/ "G/u4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons__ = __webpack_require__("N4+L");




var STORE_ONLYIM = 'onlyIm';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  data: function data() {
    return {
      isOpenNotice: true,
      isOpenVoice: true,
      onlyImportant: false,
      autoFixed: false,
      sideLeft: 'inherit',
      channelId: 0,
      channels: [{ id: 0, title: __WEBPACK_IMPORTED_MODULE_1__commons__["b" /* device */].isMobile ? '全部' : '全部快讯' }, { id: 1, title: '美股' }, { id: 2, title: '港股' }]
    };
  },

  watch: {
    isOpenNotice: function isOpenNotice(v) {
      __WEBPACK_IMPORTED_MODULE_0__commons_utils__["h" /* cookie */].set('onNotification', v ? 1 : 2);
    },
    isOpenVoice: function isOpenVoice(v) {
      __WEBPACK_IMPORTED_MODULE_0__commons_utils__["h" /* cookie */].set('onSound', v ? 1 : 2);
    },
    onlyImportant: function onlyImportant(v) {
      __WEBPACK_IMPORTED_MODULE_0__commons_utils__["h" /* cookie */].set('onImportant', v ? 1 : 2);
    }
  },
  mounted: function mounted() {
    this.getSwitchState();
    if (__WEBPACK_IMPORTED_MODULE_1__commons__["b" /* device */].isMobile) {
      new Jin10AppLauncher({
        openBlank: true,
        website: 'ushknews'
      });
    }
    this.$nextTick(function () {
      window.addEventListener('resize', this.onScroll);
      window.addEventListener('scroll', this.onScroll);
    });
  },

  methods: {
    init: function init() {
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState == 'visible') {
          location.reload(true);
        }
      });
      document.addEventListener('webkitvisibilitychange', function () {
        if (document.webkitVisibilityState == 'visible') {
          location.reload(true);
        }
      });
      document.addEventListener('mozvisibilitychange', function () {
        if (document.mozVisibilityState == 'visible') {
          location.reload(true);
        }
      });
      document.addEventListener('msvisibilitychange', function () {
        if (document.msVisibilityState == 'visible') {
          location.reload(true);
        }
      });
    },
    onOnlyImChange: function onOnlyImChange(value) {
      var store = __WEBPACK_IMPORTED_MODULE_0__commons_utils__["i" /* storage */].get(STORE_ONLYIM) || {};

      store[this.channelId] = value;
      this.onlyImportant = value;

      __WEBPACK_IMPORTED_MODULE_0__commons_utils__["i" /* storage */].set(STORE_ONLYIM, store);
    },
    onChannelChange: function onChannelChange(id) {
      this.channelId = id;
      window.jin_us_flash_channel = id;
      var store = __WEBPACK_IMPORTED_MODULE_0__commons_utils__["i" /* storage */].get(STORE_ONLYIM) || {};

      this.onlyImportant = !!store[id];
    },
    getSwitchState: function getSwitchState() {
      var notificationCookie = __WEBPACK_IMPORTED_MODULE_0__commons_utils__["h" /* cookie */].get('onNotification');
      var voiceCookie = __WEBPACK_IMPORTED_MODULE_0__commons_utils__["h" /* cookie */].get('onSound');

      if (!notificationCookie) {
        __WEBPACK_IMPORTED_MODULE_0__commons_utils__["h" /* cookie */].set('onNotification', 1);
        notificationCookie = 1;
      }
      if (!voiceCookie) {
        __WEBPACK_IMPORTED_MODULE_0__commons_utils__["h" /* cookie */].set('onSound', 1);
        voiceCookie = 1;
      }
      this.isOpenNotice = notificationCookie == 1;
      this.isOpenVoice = voiceCookie == 1;
      this.onChannelChange(0);
    },
    onScroll: function onScroll() {
      var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
      var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;

      var headerHeight = null;
      var header = document.querySelector('.ushk-header');
      if (header) {
        headerHeight = header.offsetHeight;
      }

      this.autoFixed = scrollY >= headerHeight;

      var mainWidth = this.$refs.main.clientWidth;
      var mediaMatch = window.matchMedia('(max-width:1240px)');

      if (mediaMatch.matches && this.autoFixed) {
        this.sideLeft = mainWidth + 50 - scrollX + 'px';
      } else {
        this.sideLeft = 'inherit';
      }
    }
  }
});

/***/ }),

/***/ "GBdf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/star@2x.010d110.png";

/***/ }),

/***/ "GoUn":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-wrap ushk-wrap-main"
  }, [_c('div', {
    staticClass: "ushk-price ushk-content-box"
  }, [_c('div', {
    staticClass: "ushk-price__wrap"
  }, [_c('div', {
    staticClass: "ushk-price__b"
  }, [_c('div', {
    staticClass: "ushk-price__marquee marquee3k",
    attrs: {
      "id": "J_price_marquee",
      "data-pausable": "true",
      "data-speed": "0.8"
    }
  }, _vm._l((_vm.wrapNum), function(n) {
    return _c('div', {
      staticClass: "ushk-price__group J_price_group"
    }, _vm._l((_vm.datas), function(value, key) {
      return _c('div', {
        key: key,
        staticClass: "ushk-price__item J_price_item",
        attrs: {
          "data-code": key
        }
      }, [_c('div', {
        staticClass: "ushk-price__content"
      }, [_c('h5', {
        staticClass: "ushk-price__name"
      }, [_vm._v("\n                  " + _vm._s(value.name) + "\n                  "), _c('span', [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('div', {
        staticClass: "ushk-price__value"
      }, [_c('span', {
        style: ({
          color: value.bTextColor,
          'background-color': value.bgColor
        })
      }, [_vm._v(_vm._s(value.bValue || '--'))])]), _vm._v(" "), _c('div', {
        staticClass: "ushk-price__value"
      }, [_c('span', {
        style: ({
          color: value.textColor
        })
      }, [_vm._v(_vm._s(value.pValue || '--'))]), _vm._v(" "), _c('i', {
        staticClass: "ushk-icon",
        class: 'ushk-icon_' + value.dir,
        style: ({
          color: value.textColor
        })
      })])])])
    }), 0)
  }), 0)])])])])
},staticRenderFns: []}

/***/ }),

/***/ "HKpY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notice-icon-2.2b268be.png";

/***/ }),

/***/ "Hie1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompanyList__ = __webpack_require__("f0i3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompanyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CompanyList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseFn__ = __webpack_require__("ULHC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_utils__ = __webpack_require__("j+bc");







var url = "production" === 'development' || window.location.href.includes('test') ? 'https://behavior-collection-18924143967-testing.jin10.com' : '//log-agent.jin10.com';

var env = "production" === 'development' || window.location.href.includes('test') ? 'env' : 'prod';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  components: {
    CompanyList: __WEBPACK_IMPORTED_MODULE_1__CompanyList___default.a
  },
  props: {
    data: Object,
    isShowCompanyList: {
      type: Boolean,
      default: true
    },
    did: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},


  methods: {
    onRecord: function onRecord(e) {
      if (e.target.localName === 'img') {
        var data = {
          app: 'ushknews',
          page_name: '美港电讯',
          module: '快讯',
          action: '点击',
          type: '图片广告',
          object: null,
          params: {
            url: e.target.src
          }
        };

        var protoStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([data]);
        var u8Ary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseFn__["a" /* strToUTF8Arr */])(protoStr);
        var b64Code = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseFn__["b" /* base64EncArr */])(u8Ary);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_fetch__["a" /* fetch */])({
          url: url + '/v1/web/bin',
          data: b64Code.buffer,
          type: 'post',
          headers: {
            'Content-Type': 'application/octet-stream',
            env: env,
            did: this.did
          },
          callback: function callback(res) {},
          success: function success(res) {
            resolve(res.data);
          },
          error: function error() {}
        });
      }
    },
    onRemarkClick: function onRemarkClick(data) {
      if (data.type === 'link') {
        window.open(data.link, '_blank');
        return false;
      }
      this.$emit('on-remark-click', data);
    },

    flashFormat: __WEBPACK_IMPORTED_MODULE_4__commons_utils__["l" /* flashFormat */]
  }
});

/***/ }),

/***/ "IHS+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/head-pic.3a510af.png";

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_home__ = __webpack_require__("xQAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_video__ = __webpack_require__("qLZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_calendar__ = __webpack_require__("Tmzm");









if (false) {
  Vue.use(Vuex);
}

var state = {
  user: {},
  isVideoPlaying: false,
  videoType: 'index'
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: {
    home: __WEBPACK_IMPORTED_MODULE_5__modules_home__["a" /* default */],
    video: __WEBPACK_IMPORTED_MODULE_6__modules_video__["a" /* default */],
    calendar: __WEBPACK_IMPORTED_MODULE_7__modules_calendar__["a" /* default */]
  }
}));

/***/ }),

/***/ "J2ZD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Message__ = __webpack_require__("Juq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RemarkDialog__ = __webpack_require__("5FT1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RemarkDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RemarkDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scrollmonitor__ = __webpack_require__("E1Rp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scrollmonitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scrollmonitor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_fetch__ = __webpack_require__("yR7j");









var url = "production" === "development" || window.location.href.includes("test") ? "https://behavior-collection-18924143967-testing.jin10.com" : "//log-agent.jin10.com";
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UshkMessage: __WEBPACK_IMPORTED_MODULE_1__Message___default.a,
    RemarkDialog: __WEBPACK_IMPORTED_MODULE_2__RemarkDialog___default.a
  },
  props: {
    datas: {
      type: Object,
      default: {}
    }
  },
  watch: {
    datas: function datas(v) {
      this.initScrollMonitor();
    }
  },
  mounted: function mounted() {
    this.getDid();
    this.initScrollMonitor();
  },
  data: function data() {
    return {
      curImportantRelevance: '',
      oldImportantRelevance: '',
      curRelevance: '',
      relevanceActiveClassName: 'is-relevance',
      relevanceImportantClassName: 'is-relevance-important',
      isShowRemarkDialog: false,
      remarkData: {},
      did: ''
    };
  },

  methods: {
    getDid: function getDid() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__commons_fetch__["a" /* fetch */])({
        url: url + "/v1/did",
        type: "get",
        callback: function callback(res) {},
        success: function success(res) {
          _this.did = res.data.did;
          resolve(res.data);
        },
        error: function error() {}
      });
    },
    initScrollMonitor: function initScrollMonitor() {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('.J_flash_group')).forEach(function (group) {
          var $date = group.querySelector('.J_flash_date');
          var sectionWatcher = __WEBPACK_IMPORTED_MODULE_4_scrollmonitor___default.a.create(group);
          var sectionMinusBottomHeadline = __WEBPACK_IMPORTED_MODULE_4_scrollmonitor___default.a.create(group, { bottom: 0 });

          sectionMinusBottomHeadline.stateChange(function () {
            if (!sectionWatcher.isInViewport) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["j" /* removeClass */])($date, 'is-fixed');
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["j" /* removeClass */])($date, 'is-bottom');
            } else if (sectionMinusBottomHeadline.isInViewport && sectionMinusBottomHeadline.isAboveViewport) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["k" /* addClass */])($date, 'is-fixed');
            } else if (sectionMinusBottomHeadline.isAboveViewport) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["k" /* addClass */])('is-bottom');
            } else {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["j" /* removeClass */])($date, 'is-fixed');
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["j" /* removeClass */])($date, 'is-bottom');
            }
          });
        });
      });
    },
    getMonth: function getMonth(date) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["c" /* dateFormat */])(new Date(date.replace(/-/g, '/')), 'MM');
    },
    getDay: function getDay(date) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["c" /* dateFormat */])(new Date(date.replace(/-/g, '/')), 'dd');
    },
    mouseHandle: function mouseHandle(target, isRelevanceActive) {
      var _this2 = this;

      var relevance = target.getAttribute('data-relevance');
      if (!relevance) {
        return false;
      }

      if (isRelevanceActive) {
        if (this.curRelevance === relevance) {
          clearTimeout(this.leaveTimer);
          return false;
        }
        this.curRelevance = relevance;
      } else {
        this.curRelevance = '';
      }

      var $list = document.querySelector('#J_flash_list');
      try {
        var $relevances = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()($list.querySelectorAll('.J_flash_item[data-relevance="' + relevance + '"]'));
        if ($relevances.length < 2) {
          return false;
        }
        $relevances.forEach(function ($relevance, index) {
          if (isRelevanceActive) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["k" /* addClass */])($relevance, _this2.relevanceActiveClassName);
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["j" /* removeClass */])($relevance, _this2.relevanceActiveClassName);
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    onMouseenter: function onMouseenter(e) {
      this.mouseHandle(e.currentTarget, true);
    },
    onMouseleave: function onMouseleave(e) {
      var _this3 = this;

      var target = e.currentTarget;
      if (!target.getAttribute('data-relevance')) {
        return false;
      }
      this.leaveTimer = setTimeout(function () {
        _this3.mouseHandle(target, false);
      }, 100);
    },
    onRemarkClick: function onRemarkClick(data) {
      this.isShowRemarkDialog = true;
      this.remarkData = data;
    },
    onClick: function onClick(e) {
      var _this4 = this;

      var target = e.currentTarget;
      var relevance = target.getAttribute('data-relevance');
      if (!relevance) {
        return false;
      }
      if (!this.curImportantRelevance || this.curImportantRelevance !== relevance) {
        this.curImportantRelevance = relevance;
      } else {
        this.curImportantRelevance = '';
      }
      var $list = document.querySelector('#J_flash_list');
      if (this.oldImportantRelevance && relevance !== this.oldImportantRelevance) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()($list.querySelectorAll('.J_flash_item[data-relevance="' + this.oldImportantRelevance + '"]')).forEach(function ($relevance, index) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["j" /* removeClass */])($relevance, _this4.relevanceImportantClassName);
        });
      }
      var $relevances = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()($list.querySelectorAll('.J_flash_item[data-relevance="' + relevance + '"]'));
      $relevances.forEach(function ($relevance, index) {
        if (relevance === _this4.oldImportantRelevance) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["j" /* removeClass */])($relevance, _this4.relevanceImportantClassName);
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_utils__["k" /* addClass */])($relevance, _this4.relevanceImportantClassName);
        }
      });
      this.oldImportantRelevance = this.curImportantRelevance;
      this.$emit('mouseHandle', this.curImportantRelevance);
    }
  }
});

/***/ }),

/***/ "Juq6":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Hie1"),
  /* template */
  __webpack_require__("Wpw8"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "LW1D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-01@2x.c8bef05.png";

/***/ }),

/***/ "M3LB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/head-pic-01.578986e.png";

/***/ }),

/***/ "MA7u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/accessData.501faa3.jpg";

/***/ }),

/***/ "NA1v":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAJCAYAAACCPip6AAAChklEQVRIS7WVS2jUUBSG/5OQ6Ij42vgAKZ2SmzuMQwW7UiuKi4IuFOxOl261ivjA18IXaqFY3brUXQVdKHQhSquuKijTYW7u0ClF8LHxhTiakDmS0inTkBlmYbJL/vvnfPnvOTeE2FWpVAaiR47jjMe1VvelUmmlaZrnpJQXO/VE65RS18IwvJnP53916vvffNRcmJlNrfX76JkQopeIwk7AtNZXmPk8EfUJId516NnKzFNEdEMIcbkTTxp8iwGUSiXbNM0hALcXYM6EYTiaz+f9dnCe5/Uy8xsAKwC8yGQyh7q6ur6188zNza2t1WqPAOwB8JuItruuOx98my5LhY8qlcpgGIZnARQALIsB/AVQNE3zluM4Yw2tWCxutizrPoA+AOtiHiaiKhE9dRznBBFxpDNzVOsOM+9n5iyAJd0H4CuAqSAIjhYKhQ+Nd6bONzs7u9z3/XFm3pWUPhFN2LY90N3d/adZ11qfrtfrjW5ZYiWi7wB2x3c16hYAL5l5TVItwzDOCCGGm7W0+eZ3YWZmZnUQBK8AbImBTVuWtbOnp+dHEnC5XB4hopMxLSCiva7rTiZ5PM/rZ+bnAKxmnYhGXNc9leRJk2+xDZVSDwAcjgE8lFIeaTWXSqkDAB7Hx8Z13Uyj9ePeaBQ8z6sljNtBKeWTNrVS4WsOYAJAP4BPCxAbAUxKKRNHI1pTLpePEdFdANFBqRsdZNv2hmw2+yXpY6rV6nrf9z8vaNPRDweAzczHc7ncvTYBpMLXHMAzAGNhGEZJwzTNaOcHpZT7WkFprS/U6/VVAEallB+VUjuIKDobruZyubctxmabYRiXmHlYSvlaKbUJwJBhGD+FENfbBJAK3z/aan4XMQuCbwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "NSa5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAJCAYAAACCPip6AAACtElEQVRIS7WTTUgUYRjH/8/MumuRZoFYtrvRBx2yMMhT+TGDhVCQuutClIcOXcsitOjr0BeVIFnXDh0sgnV3NSiQkhk/6mRQpB2iD9rdLBHKNErXnXlixJV1mpU9NHMYeN/n/fP83v/7/AmmLyr7a4wtrxLqMdcyrUekwIo86Ge8auh8thrjXFTyX5mCcL1EDf7KVve/+Si9MQcCYmxce23seQrFUgoGtWzA4rLvEjPOJqGXbVC7XmWj+STV7XBAGCLCNbcSvpiNxg6+BQNGtgac+YV6ExPfNGCIqWVyXGgveRtMLAUXl+tLdZ1egLCcACUvmesvGHzwYynNRPmhVVOO6RADMhi/BYF3uZXInPEZp8wmPopLgQYd2mkA2wG4TAAzAN4IEG+41WBnqva+stbjEh13WecyEFabNAzgIxE9diuhEwQYa+NHcdl/i5n3A9hoeLxIx/hOAg3NaMmjm/u7Y6ma7XwsHcmN02QPMyqt3CdCv5vza0i9N51ej1X5m1PTYqGbEIgl86vOTQuTCqDAshdTi6cv1Looljbzzb3Chz2BlTlJbRDANhPY8KxDLN/0LPjTCjgq+9vAfHIRMGM2xyFUF/d2DlhpRqsbKmaTei8RctLrAnObuy9yykpjJ9/CGMYkXwcDh9MBCLjvUcONmXIZletrwdRljo1HDS9Ljb5Za0QhJvn+/BM34jqvEunO1MsuvgUDolJ9P0AVAL7OQ6wFeMCrRiyjYZz5XOU7RoTbzEgQ4V1qglxick1R76Mxq8uMVR8omtEc3+Zrw8zYQgQnM46v7wvfyWi2TXzpBjwBCZ2eMaHDgIgV6Y1gvcGrRvZlhvKfI+b8XKezvfDpw9Evsm+3ztQskna5WOl6aRkBuW6nxuIFgbh1nRJ+Pr73YPF0ItHERJNeNXR1CQNs4fsLmYeeGQe6QX0AAAAASUVORK5CYII="

/***/ }),

/***/ "OgBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isIe = function isIe() {
  var rv = -1;
  if (navigator.appName == 'Microsoft Internet Explorer') {
    var ua = navigator.userAgent;
    var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
    if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
  }
  return rv;
};
var sound = function () {
  var browserVer = isIe();
  var bgm = void 0;
  var src = '//cdn.jin10.com/assets/media/notice.wav?20170216';
  if (browserVer > -1 && browserVer < 9) {
    document.body.insertAdjacentHTML('beforeend', '<embed id="J_audiotagIE" src="' + src + '" autostart="false" loop="false" width="0" height="0"></embed>');
    bgm = document.getElementById('J_audiotagIE');
  } else {
    bgm = new Audio();
    bgm.src = src;
    bgm.loop = false;
  }

  return {
    play: function play() {
      bgm.loop = typeof loop !== 'undefined' ? loop : false;
      bgm.play();
    },
    pause: function pause() {
      bgm.pause();
    }
  };
}();
/* harmony default export */ __webpack_exports__["a"] = (sound);

/***/ }),

/***/ "PZPv":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-content"
  }, [_c('div', {
    ref: "main",
    staticClass: "ushk-content-box"
  }, [_c('div', {
    staticClass: "ushk-news"
  }, [_c('div', {
    staticClass: "ushk-news__h ushk-news__h_tabs"
  }, [_c('div', {
    staticClass: "ushk-news__logo",
    on: {
      "click": function($event) {
        return _vm.onChannelChange(0)
      }
    }
  }, [_c('i')]), _vm._v(" "), _c('div', {
    staticClass: "ushk-news__h_tabs"
  }, _vm._l((_vm.channels), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ushk-news__h_tab",
      class: {
        active: _vm.channelId === item.id
      },
      on: {
        "click": function($event) {
          return _vm.onChannelChange(item.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ushk-news__handle"
  }, [_c('ushk-switch', {
    attrs: {
      "text": "通知"
    },
    model: {
      value: (_vm.isOpenNotice),
      callback: function($$v) {
        _vm.isOpenNotice = $$v
      },
      expression: "isOpenNotice"
    }
  }), _vm._v(" "), _c('ushk-switch', {
    attrs: {
      "text": "声音"
    },
    model: {
      value: (_vm.isOpenVoice),
      callback: function($$v) {
        _vm.isOpenVoice = $$v
      },
      expression: "isOpenVoice"
    }
  }), _vm._v(" "), _c('ushk-switch', {
    attrs: {
      "text": "只看重要"
    },
    on: {
      "input": _vm.onOnlyImChange
    },
    model: {
      value: (_vm.onlyImportant),
      callback: function($$v) {
        _vm.onlyImportant = $$v
      },
      expression: "onlyImportant"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ushk-news__b"
  }, [_c('flash-list', {
    attrs: {
      "currentChannel": _vm.channelId,
      "is-open-notice": _vm.isOpenNotice,
      "is-open-voice": _vm.isOpenVoice,
      "only-important": _vm.onlyImportant
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-side"
  }, [_c('div', {
    staticClass: "ushk-side__wrap",
    style: ({
      left: _vm.sideLeft
    })
  }, [_c('ad'), _vm._v(" "), _c('contract'), _vm._v(" "), _c('Declatration')], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ "QqS3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhongjin@2x.8450a4d.png";

/***/ }),

/***/ "R3P1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__option__ = __webpack_require__("/E17");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_socket__ = __webpack_require__("uWYQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons__ = __webpack_require__("N4+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_marquee__ = __webpack_require__("mwBI");









var $socket = null;
function filterMessage(val) {
  return val.toFixed(2);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: {},
  data: function data() {
    return {
      datas: __WEBPACK_IMPORTED_MODULE_1__option__["a" /* priceOptionDatas */],
      wrapNum: 2,
      groupNum: 8,
      timer: {},
      locations: [],
      curLocation: 0,
      subscribeText: [],
      subscribeIndex: 0,
      initedMerquee: false,
      marqueeWidth: 0
    };
  },

  watch: {
    subscribeText: function subscribeText(v) {
      var delIndex = 0;
      var index = this.subscribeIndex;
      if (index >= 2 && index < this.groupNum) {
        delIndex = index - 2;
      } else if (index === 0) {
        delIndex = this.groupNum - 2;
      } else {
        delIndex = this.groupNum - index;
      }
      if ($socket) {
        $socket.emit('delAllSubscription', this.locations[delIndex].subscription);
        $socket.emit('addSubscription', v);
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },

  methods: {
    init: function init() {
      if (__WEBPACK_IMPORTED_MODULE_4__commons__["b" /* device */].isMobile) {
        return false;
      }
      if (true) {
        $socket = new __WEBPACK_IMPORTED_MODULE_2__plugins_socket__["a" /* default */]({
          jsUrl: 'https://www.jin10.com/js/pserver.js',
          jsName: 'pServerArr'
        });
        this.onSocket();
      }
    },
    onSocket: function onSocket() {
      var _this = this;

      $socket && $socket.connection.then(function (socket) {
        socket.on('connect', _this.connect);
        socket.on('price list', function (msg) {
          _this.update(msg);
        });
      });
    },
    initMarquee: function initMarquee() {
      var _this2 = this;

      this.getLocation();
      this.marqueeWidth = document.getElementById('J_price_marquee').offsetWidth;
      if (this.initedMerquee) {
        return false;
      }
      this.initedMerquee = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_5__plugins_marquee__["a" /* default */].init({
          selector: 'marquee3k',
          isCustomContent: true,
          wrapper: document.querySelector('.ushk-price__marquee'),
          callback: function callback(_ref) {
            var offset = _ref.offset,
                width = _ref.width;

            offset = Math.floor(Math.abs(offset));
            if (offset > width - _this2.marqueeWidth) {
              if (_this2.curLocation) {
                _this2.curLocation = 0;
                _this2.subscribeIndex = 0;
                _this2.subscribeText = _this2.locations[0].subscription;
              }
            } else {
              _this2.locations.forEach(function (item, i) {
                if (offset === item.left - _this2.marqueeWidth && offset !== _this2.curLocation) {
                  _this2.curLocation = item.left;
                  _this2.subscribeText = item.subscription;
                  _this2.subscribeIndex = i;
                }
              });
            }
          }
        });
      }, 4000);
    },
    connect: function connect() {
      var _this3 = this;

      var subscribeText = this.locations[this.subscribeIndex] ? this.locations[this.subscribeIndex].subscription : __WEBPACK_IMPORTED_MODULE_1__option__["b" /* subscription */].slice(0, this.groupNum);
      $socket.emit('delAllSubscription', []);
      $socket.emit('addSubscription', subscribeText);
      $socket.emit('reg', 'ok');
      setTimeout(function () {
        _this3.initMarquee();
      }, 1000);
    },
    update: function update(msg) {
      var _this4 = this;

      var name = msg.name;
      if (!this.datas[name]) {
        return false;
      }
      var newValue = msg.v.lp;
      var oldValue = this.datas[name] && this.datas[name].bValue;
      var bgColor;
      var textColor = 'grey';
      var dirP;

      if (Number(newValue) > Number(oldValue)) {
        bgColor = '#e24052';
      } else if (Number(newValue) < Number(oldValue)) {
        bgColor = '#36a984';
      } else if (Number(newValue) == Number(oldValue)) {
        return;
      }
      if (msg.v.ch != null) {
        var per = msg.v.ch / (msg.v.lp - msg.v.ch) * 100;
        if (Number(per) > 0) {
          textColor = '#e24052';
          dirP = 'up';
        } else if (Number(per) < 0) {
          textColor = '#36a984';
          dirP = 'down';
        } else {
          textColor = '#fff';
        }
        this.datas[name].textColor = textColor;
        this.datas[name].bTextColor = textColor;
        this.datas[name].pValue = filterMessage(per) + '%';
        this.datas[name].dir = dirP;
      }
      var id = null;
      if (typeof this.timer[name] === 'undefined') {
        this.timer[name] = null;
      }
      id = this.timer[name];
      if (id != null && id != 0) {
        clearTimeout(id);
      }
      this.datas[name].bgColor = bgColor;
      this.datas[name].bTextColor = '#fff';
      this.datas[name].bValue = filterMessage(parseFloat(msg.v.lp));

      var mm = setTimeout(function () {
        _this4.datas[name].bgColor = 'transparent';
        _this4.datas[name].bTextColor = _this4.datas[name].textColor;
        _this4.timer[name] = 0;
      }, 600);
      this.timer[name] = mm;
    },
    getLocation: function getLocation() {
      var $group = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('.J_price_group'))[0];
      var $items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()($group.querySelectorAll('.J_price_item'));
      var length = $items.length;
      var groupNum = this.groupNum;
      var itemNum = Math.floor(length / groupNum);
      var remainder = length % groupNum;
      var locations = [];
      this.locations = [];
      $items.forEach(function (item) {
        locations.push(item.offsetLeft);
      });
      for (var i = 0; i < groupNum; i++) {
        var groupIndex = itemNum * i;
        var num = itemNum * (i + 1);
        if (i + 1 === groupNum && remainder) {
          num += remainder;
        }
        this.locations.push({
          left: Math.floor(locations[groupIndex]),
          subscription: __WEBPACK_IMPORTED_MODULE_1__option__["b" /* subscription */].slice(groupIndex, num)
        });
      }
    }
  }
});

/***/ }),

/***/ "RTXE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-03.f00a408.png";

/***/ }),

/***/ "StUP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/money@2x.99fc5bd.png";

/***/ }),

/***/ "Tmzm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_headers__ = __webpack_require__("+mDD");





var state = {
  stockAffect: {}
};

var getters = {
  stockAffect: function stockAffect(state) {
    return state.stockAffect;
  }
};

var actions = {
  getStockAffect: function getStockAffect(_ref) {
    var _this = this;

    var commit = _ref.commit;
    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    console.log(date);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_fetch__["a" /* fetch */])({
        url: __WEBPACK_IMPORTED_MODULE_2__commons_config__["a" /* requestUrl */].rili.stockAffect,
        params: {
          date: date
        },
        headers: __WEBPACK_IMPORTED_MODULE_3__commons_headers__["a" /* calendarHeaders */],
        type: 'GET',

        useJson: true,

        callback: function callback(_ref2) {
          var data = _ref2.data;

          commit('SET_STOCK_AFFECT', data);
          resolve(data);
        },
        success: function success(_ref3) {
          var data = _ref3.data;

          commit('SET_STOCK_AFFECT', data);
          resolve(data);
        },
        error: function error() {
          reject();
        }
      });
    });
  }
};

var mutations = {
  SET_STOCK_AFFECT: function SET_STOCK_AFFECT(state, data) {
    state.stockAffect = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "ULHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return base64EncArr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strToUTF8Arr; });
function base64EncArr(aBytes) {
  var eqLen = (3 - aBytes.length % 3) % 3,
      codeAry = [];

  for (var nMod3, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++) {
    nMod3 = nIdx % 3;

    nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);
    if (nMod3 === 2 || aBytes.length - nIdx === 1) {
      codeAry.push(nUint24 >>> 18 & 63, nUint24 >>> 12 & 63, nUint24 >>> 6 & 63, nUint24 & 63);
      nUint24 = 0;
    }
  }

  if (eqLen === 0) return Uint8Array.from(codeAry);

  var b64ChartCode = codeAry.slice(0, codeAry.length - eqLen);
  if (eqLen === 1) {
    b64ChartCode.push(128);
  } else {
    b64ChartCode.push(128, 128);
  }

  return Uint8Array.from(b64ChartCode);
}

function strToUTF8Arr(sDOMStr) {
  var aBytes,
      nChr,
      nStrLen = sDOMStr.length,
      nArrLen = 0;

  for (var nMapIdx = 0; nMapIdx < nStrLen; nMapIdx++) {
    nChr = sDOMStr.charCodeAt(nMapIdx);
    nArrLen += nChr < 0x80 ? 1 : nChr < 0x800 ? 2 : nChr < 0x10000 ? 3 : nChr < 0x200000 ? 4 : nChr < 0x4000000 ? 5 : 6;
  }

  aBytes = new Uint8Array(nArrLen);

  for (var nIdx = 0, nChrIdx = 0; nIdx < nArrLen; nChrIdx++) {
    nChr = sDOMStr.charCodeAt(nChrIdx);
    if (nChr < 128) {
      aBytes[nIdx++] = nChr;
    } else if (nChr < 0x800) {
      aBytes[nIdx++] = 192 + (nChr >>> 6);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else if (nChr < 0x10000) {
      aBytes[nIdx++] = 224 + (nChr >>> 12);
      aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else if (nChr < 0x200000) {
      aBytes[nIdx++] = 240 + (nChr >>> 18);
      aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else if (nChr < 0x4000000) {
      aBytes[nIdx++] = 248 + (nChr >>> 24);
      aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else {
        aBytes[nIdx++] = 252 + (nChr >>> 30);
        aBytes[nIdx++] = 128 + (nChr >>> 24 & 63);
        aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
        aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
        aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
        aBytes[nIdx++] = 128 + (nChr & 63);
      }
  }

  return aBytes;
}



/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogin", function() { return isLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReadname", function() { return isReadname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVideoPlaying", function() { return isVideoPlaying; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "videoType", function() { return videoType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);


var user = function user(state) {
  return state.user;
};

var options = function options(state) {
  return state.options;
};

var isLogin = function isLogin(state) {
  return !!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.user).length;
};

var isReadname = function isReadname(state, getters) {
  return getters.isLogin && state.user.cert.name && state.user.cert.status === 1;
};

var isVideoPlaying = function isVideoPlaying(state) {
  return state.isVideoPlaying;
};

var videoType = function videoType(state) {
  return state.videoType;
};

/***/ }),

/***/ "Uq1x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kexinwangzhan.fcb135b.png";

/***/ }),

/***/ "UsCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MessageGroup__ = __webpack_require__("+8bK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MessageGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MessageGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filter__ = __webpack_require__("8ttZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_socket__ = __webpack_require__("uWYQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sound__ = __webpack_require__("OgBB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__push__ = __webpack_require__("x58Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__("NYxO");
















var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* createNamespacedHelpers */])('calendar'),
    mapActions = _createNamespacedHelp.mapActions,
    mapGetters = _createNamespacedHelp.mapGetters;

var $socket = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  components: {
    UshkMessageGroup: __WEBPACK_IMPORTED_MODULE_4__MessageGroup___default.a
  },
  props: {
    isOpenVoice: Boolean,
    isOpenNotice: Boolean,
    onlyImportant: Boolean,
    currentChannel: {
      type: Number,
      default: 0
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapGetters(['stockAffect']), {
    renderDatas: function renderDatas() {
      var _this2 = this;

      if (this.onlyImportant) {
        var data = {};
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.filteredDatas).forEach(function (key) {
          data[key] = _this2.filteredDatas[key].filter(function (item) {
            return item.type === 0 ? item.important : item.data.star >= 3;
          });
        });
        return data;
      } else {
        return this.filteredDatas;
      }
    }
  }),
  watch: {
    currentChannel: function currentChannel() {

      this.channel = this.currentChannel ? this.currentChannel : null;

      this.datas = [];
      this.filteredDatas = {};
      this.getData({
        params: {
          max_time: undefined,
          channel: this.channel
        }
      });
    }
  },
  data: function data() {
    return {
      datas: [],
      filteredDatas: {},
      lastID: undefined,
      isLoading: false,
      curImportantRelevance: '',
      channel: 0,
      irFirstConnect: true
    };
  },
  created: function created() {
    var _this3 = this;

    this.getStockAffect().then(function () {
      _this3.render();
      _this3.init();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapActions(['getStockAffect']), {
    init: function init() {
      this.socket();

      window.testUpdate = this.update;
    },
    socket: function socket() {
      var _this = this;
      window.Jin10FlashInstance = new Jin10USFlash({
        conectedCallback: function conectedCallback(socket) {
          console.log('conectedCallback', socket);
        },
        modifyChanelAddCallback: function modifyChanelAddCallback(datas) {
          console.log('modifyChanelAddCallback', datas);
          _this.handleData(datas);
        },
        addCallback: function addCallback(datas) {
          console.log('addCallback', datas);
          _this.handleData(datas);
        },
        modifyCallback: function modifyCallback(datas) {
          console.log('modifyCallback', datas);
          _this.handleData(datas);
        },
        delCallback: function delCallback(datas) {
          console.log('delCallback', datas);
          _this.handleData(datas);
        },
        reloadCallback: function reloadCallback(datas) {
          console.log('reloadCallback', datas);
          _this.handleData(datas);
        },
        allMessageCallback: function allMessageCallback(_ref) {
          var opcode = _ref.opcode,
              type = _ref.type,
              datas = _ref.datas,
              buf = _ref.buf;
        }
      });
    },
    handleData: function handleData(data) {
      var channel = data.channel;

      if (!this.channel) {
        this.update(data);
      } else if ((channel || []).indexOf(parseInt(this.channel)) > -1) {
        this.update(data);
      }
    },
    getData: function getData() {
      var _this4 = this;

      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.isLoading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__commons_fetch__["a" /* fetch */])({
          url: 'https://flash-api.ushknews.com/get_flash_list_with_channel',
          params: payload.params || {
            max_time: _this4.lastID,
            channel: !_this4.channel ? '' : _this4.channel
          },
          type: 'get',
          useJson: true,
          headers: {
            'x-version': '1.0.0',
            'x-app-id': 'brCYec5s1ova317e'
          },
          callback: function callback(res) {
            _this4.isLoading = false;
          },
          success: function success(res) {
            var datas = res.data;

            if (!datas.length) {
              return false;
            }

            datas.forEach(function (data) {
              var action = payload.isUpdate ? 'unshift' : 'push';
              if (_this4.datas.findIndex(function (item) {
                return item.id === data.id;
              }) !== -1) {
                return false;
              }
              if (data.type === 0 && data.data.lock) {
                return false;
              }
              data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filter__["a" /* filterData */])(data, false, _this4.stockAffect);
              var date = data.date;
              if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this4.filteredDatas).length) {
                _this4.generateDate(date);
              }

              if (payload.isLower && _this4.curImportantRelevance && data.type === 0 && data.relevance === _this4.curImportantRelevance) {
                data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, { isRelevanceImportant: true });
              }
              if (!_this4.filteredDatas[date]) {
                _this4.$set(_this4.filteredDatas, date, []);
              }
              if (payload.isUpdate) {
                _this4.updateData(data, date);
              } else {
                _this4.filteredDatas[date].push(data);
              }
              _this4.datas[action](data);
            });
            resolve(_this4.filteredDatas);
          },
          error: function error() {
            _this4.isLoading = false;
          }
        });
      });
    },
    render: function render() {
      this.getData();
    },
    generateDate: function generateDate(nowDate) {
      nowDate = nowDate.replace(/-/g, '/');
      var nowTime = new Date(nowDate).getTime();
      var dayTime = 86400000;
      for (var i = 30; i >= 0; i--) {
        var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__commons_utils__["c" /* dateFormat */])(new Date(nowTime + dayTime * i), 'yyyy-MM-dd');
        this.$set(this.filteredDatas, date, []);
      }
    },
    sliceDate: function sliceDate(dateId) {
      var y = dateId.slice(0, 4);
      var m = dateId.slice(4, 6);
      var d = dateId.slice(6, 8);
      return y + '-' + m + '-' + d;
    },
    update: function update(data) {
      var _data = data,
          type = _data.type,
          action = _data.action,
          id = _data.id,
          channel = _data.channel;

      var date = id ? this.sliceDate(id) : '';
      var datas = this.filteredDatas[date];
      var index = datas ? datas.findIndex(function (item) {
        return item.id === id;
      }) : 0;
      if (action && action !== 1) {
        if (index === -1) {
          return false;
        }
        if (action === 2) {
          if (data.data) {
            var curData = datas[index];
            var fData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filter__["a" /* filterData */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, curData, data), true, this.stockAffect);
            this.$set(this.filteredDatas[date], index, fData);
          }
        } else if (action === 3) {
          this.$delete(this.filteredDatas[date], index);
        } else if (action === 6) {
          var time = Math.floor(Math.random() * 30 + 1) - 1;
          setTimeout(function () {
            window.location.reload();
          }, time * 1000);
        }
        return false;
      }
      if (index !== -1) {
        return false;
      }
      data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filter__["a" /* filterData */])(data, true, this.stockAffect);
      this.datas.unshift(data);
      if (data.type === 0 && data.relevance === this.curImportantRelevance && this.curImportantRelevance) {
        data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, { isRelevanceImportant: true });
      }
      if (!this.filteredDatas[date]) {
        this.$set(this.filteredDatas, date, []);
      }
      this.updateData(data, date);
      if (this.isOpenVoice) {
        __WEBPACK_IMPORTED_MODULE_10__sound__["a" /* default */].play();
      }
      if (!this.isOpenNotice || !data.important) {
        return false;
      }
      var notificationTitle = '美港电讯 - ' + location.origin.replace('https://', '');
      var notificationOptions = {
        timeout: 8000,
        onClick: function onClick() {
          window.focus();
          this.close();
        }
      };
      if (data.type == 0) {
        notificationOptions.icon = data.data.pic ? data.data.pic : location.origin + '/img/notice-icon.png';
        notificationOptions.body = data.data.content.replace(/<br \/>/gi, '\n').replace(/<[^>]+>/g, '');
      } else {
        notificationOptions.icon = '//cdn.jin10.com/assets/img/commons/flag/flash/' + data.data.country + '.png';
        notificationOptions.body = data.time_view + ' ' + data.data.content + '\n前值：' + data.data.previous || '' + ' 预期：' + data.data.consensus || '' + ' 实际：' + data.data.actual || '' + '\n解读：理论上较为【' + data.data.evaluate + '】股票价格';
      }
      __WEBPACK_IMPORTED_MODULE_11__push__["a" /* default */].create(notificationTitle, notificationOptions);
    },
    updateData: function updateData(data, date) {
      var id = data.id;

      var datas = this.filteredDatas[date];
      if (datas.length) {
        for (var i = 0, l = datas.length; i < l; i++) {
          if (id > datas[i].id) {
            this.filteredDatas[date].splice(i, 0, data);
            break;
          }
        }
      } else {
        this.filteredDatas[date].push(data);
      }
    },
    lower: function lower() {
      this.lastID = this.datas[this.datas.length - 1].time;
      this.getData({ isLower: true });
    },
    mouseHandle: function mouseHandle(curImportantRelevance) {
      this.curImportantRelevance = curImportantRelevance;
    }
  })
});

/***/ }),

/***/ "UxDv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tencent@2x.6ed0398.png";

/***/ }),

/***/ "VkxO":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("UsCt"),
  /* template */
  __webpack_require__("wz0z"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "VwCb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-sm.655b81d.png";

/***/ }),

/***/ "WfM0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-calendar.f2fd14f.png";

/***/ }),

/***/ "Wpw8":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-flash_item J_flash_item",
    class: [{
      'is-relevance': _vm.data.isRelevanceActive,
      'is-relevance-important': _vm.data.isRelevanceImportant,
    } ],
    attrs: {
      "data-relevance": _vm.data.type === 0 && _vm.data.relevance ? _vm.data.relevance : null
    }
  }, [_c('div', {
    staticClass: "ushk-flash_h"
  }, [_c('div', {
    staticClass: "ushk-flash_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_time"
  }, [_vm._v(_vm._s(_vm.data.time_view))])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_b"
  }, [(_vm.data.type === 0) ? _c('div', {
    class: [
      _vm.data.type === 0 ? {
        important: _vm.data.important
      } : '',
      _vm.data.data.star ?
      _vm.data.data.type === 1 ?
      ("star" + (_vm.data.data.star)) :
      _vm.data.data.star > 2 ?
      'important' :
      '' :
      '' ]
  }, [_c('div', {
    staticClass: "ushk-flash_text",
    class: {
      'is-only-text': !_vm.data.data.pic
    }
  }, [_c('div', {
    staticClass: "ushk-flash_text-box",
    on: {
      "click": _vm.onRecord
    }
  }, [(_vm.data.data.title) ? _c('div', {
    staticClass: "ushk-flash_text-box_title"
  }, [_c('b', [_vm._v(_vm._s(_vm.data.data.title))])]) : _vm._e(), _vm._v(" "), (_vm.data.data.tag) ? _c('span', {
    staticClass: "ushk-flash_text-tag"
  }, [_vm._v(_vm._s(_vm.data.data.tag))]) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.flashFormat(_vm.data))
    }
  }), _vm._v(" "), (_vm.data.data.link) ? _c('a', {
    staticClass: "ushk-flash_text-more1",
    attrs: {
      "href": _vm.data.data.link,
      "target": "_blank"
    }
  }, [_vm._v("阅读更多"), _c('i', {
    staticClass: "ushk-icon ushk-icon_rightArrow"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.data.data.pic) ? _c('div', {
    staticClass: "ushk-flash_attach"
  }, [(_vm.data.data.pic) ? _c('viewer', {
    staticClass: "ushk-flash_image",
    attrs: {
      "options": {
        url: 'data-source'
      }
    }
  }, [(_vm.data.isSocket) ? _c('img', {
    attrs: {
      "src": _vm.data.data.picLite,
      "data-source": _vm.data.data.pic
    }
  }) : _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.data.data.picLite),
      expression: "data.data.picLite"
    }],
    attrs: {
      "data-source": _vm.data.data.pic
    }
  })]) : _vm._e()], 1) : _vm._e()]) : (_vm.data.type === 1 || _vm.data.type === 3) ? [_c('div', {
    staticClass: "ushk-flash_data"
  }, [_c('h4', {
    staticClass: "ushk-flash_data-title"
  }, [_c('div', {
    staticClass: "ushk-flash_data-country"
  }, [(_vm.data.isSocket) ? _c('img', {
    attrs: {
      "src": ("//cdn.jin10.com/assets/img/commons/flag/" + (_vm.data.data.country) + ".png")
    }
  }) : _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (
        ("//cdn.jin10.com/assets/img/commons/flag/" + (_vm.data.data.country) + ".png")
      ),
      expression: "\n                `//cdn.jin10.com/assets/img/commons/flag/${data.data.country}.png`\n              "
    }]
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.data.content))])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_data-text"
  }, [_c('p', [_c('span', [_vm._v("前值：")]), _vm._v(_vm._s(_vm.data.data.previous || "--"))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("预期：")]), _vm._v(_vm._s(_vm.data.data.consensus || "--"))]), _vm._v(" "), _c('p', {
    staticClass: "ushk-flash_data-published"
  }, [_c('span', [_vm._v("公布：")]), _vm._v(" "), _c('b', {
    class: _vm.data.data.evaluateClass
  }, [_vm._v(_vm._s(_vm.data.data.actual))])])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_data-correction",
    attrs: {
      "id": _vm.data.data.data_id
    }
  }, [_vm._v("\n          " + _vm._s(_vm.data.data.revised) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_data-wrap"
  }, [_c('div', {
    staticClass: "ushk-flash_data-vote"
  }, [_c('star', {
    attrs: {
      "tag-name": "p",
      "width": _vm.data.data.star
    }
  })], 1), _vm._v(" "), (_vm.data.data.show_affect && _vm.data.data.country !== '中国') ? _c('div', {
    staticClass: "ushk-flash_data-tag ushk-tag_trend"
  }, [_c('p', {
    class: _vm.data.data.evaluateClass
  }, [_c('span', {
    staticClass: "ushk-btn J_kind_tag",
    attrs: {
      "data-trend": _vm.data.data.trend
    }
  }, [_c('em', {
    staticClass: "J_kind_trend"
  }, [_vm._v(_vm._s(_vm.data.data.evaluate))]), _vm._v(" "), _c('i', {
    staticClass: "J_kind_trendType"
  }, [_vm._v(_vm._s(_vm.data.data.kind))])])])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "ushk-flash_data-pubdate"
  }, [_vm._v(_vm._s(_vm.data.data.pubDate))])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash-remark-con"
  }, [(_vm.data.data.sentiment) ? _c('img', {
    attrs: {
      "src": __webpack_require__("zfj7")("./" + (_vm.data.data.sentiment) + ".png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.remark) ? _c('ul', {
    staticClass: "ushk-flash-remark"
  }, _vm._l((_vm.data.remark), function(remarkItem, index) {
    return (!remarkItem.lock) ? _c('li', {
      staticClass: "ushk-flash-remark__item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onRemarkClick(remarkItem)
        }
      }
    }, [_c('i', {
      staticClass: "ushk-icon",
      class: ("ushk-icon_remark-" + (remarkItem.type))
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(remarkItem.title))])]) : _vm._e()
  }), 0) : _vm._e()])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "WrAD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-04.2550f09.png";

/***/ }),

/***/ "Ycs1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/remark-content.ab94021.png";

/***/ }),

/***/ "YqNy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([])),
  props: {
    text: String,
    type: String,
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value(v) {
      this.isOpen = v;
    },
    isOpen: function isOpen(v) {
      this.$emit('input', v);
    }
  },
  data: function data() {
    return {
      isOpen: this.value
    };
  }
});

/***/ }),

/***/ "Z2Ax":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo@2x.ab870d1.png";

/***/ }),

/***/ "Z3oC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-02.669412a.png";

/***/ }),

/***/ "ZQHk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-2.87e96ed.png";

/***/ }),

/***/ "ZY5R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/remark-link.4558ce0.png";

/***/ }),

/***/ "ZaBU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/money-active@2x.2df6ab3.png";

/***/ }),

/***/ "ahqO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chengxinwangzhan@2x.4a4b433.png";

/***/ }),

/***/ "awGH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-02@2x.9c2d371.png";

/***/ }),

/***/ "bIbA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_home__ = __webpack_require__("hEtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_home__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'appStatic',
  computed: {},
  components: {
    Home: __WEBPACK_IMPORTED_MODULE_0__pages_home___default.a
  },
  created: function created() {}
});

/***/ }),

/***/ "ck8E":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/money-important.ba2afad.png";

/***/ }),

/***/ "dWG8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-04@2x.9749977.png";

/***/ }),

/***/ "dgx8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bearish.e1e2379.png";

/***/ }),

/***/ "dpXS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/remark-video.e7b7531.png";

/***/ }),

/***/ "eANS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/remark-data.0b1e876.png";

/***/ }),

/***/ "eGjY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/head-pic@2x.5f056dc.png";

/***/ }),

/***/ "eMRG":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-news-switch"
  }, [_c('div', {
    staticClass: "ushk-news-switch__h"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "ushk-news-switch__b"
  }, [_c('jin-switch', {
    class: {
      'is-open': _vm.isOpen
    },
    attrs: {
      "on-text": "",
      "off-text": "",
      "width": 36
    },
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "ekTD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/head-pic.2ff80e2.png";

/***/ }),

/***/ "f0i3":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("qOm8"),
  /* template */
  __webpack_require__("pIJq"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "fTYF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "feRo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/renzhenglianmeng.4c9faf7.png";

/***/ }),

/***/ "gBM3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kexinwangzhan@2x.68a19e0.png";

/***/ }),

/***/ "gzg6":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.datas), function(data, key) {
    return (data && data.length) ? _c('div', {
      key: key,
      staticClass: "ushk-flash__group J_flash_group"
    }, [_c('div', {
      staticClass: "ushk-flash__date J_flash_date"
    }, [_c('dl', [_c('dt', [_vm._v(_vm._s(_vm.getDay(key)))]), _c('dd', [_vm._v(_vm._s(_vm.getMonth(key)) + "月")])])]), _vm._v(" "), _vm._l((data), function(item) {
      return _c('ushk-message', {
        key: item.id,
        attrs: {
          "did": _vm.did,
          "data": item
        },
        on: {
          "on-remark-click": _vm.onRemarkClick
        },
        nativeOn: {
          "mouseenter": function($event) {
            return _vm.onMouseenter($event)
          },
          "mouseleave": function($event) {
            return _vm.onMouseleave($event)
          },
          "click": function($event) {
            return _vm.onClick($event)
          }
        }
      })
    })], 2) : _vm._e()
  }), _vm._v(" "), _c('remark-dialog', {
    attrs: {
      "remarkData": _vm.remarkData
    },
    model: {
      value: (_vm.isShowRemarkDialog),
      callback: function($$v) {
        _vm.isShowRemarkDialog = $$v
      },
      expression: "isShowRemarkDialog"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "h3wr":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk ushk-index",
    attrs: {
      "id": "J_ushk"
    }
  }, [_c('div', {
    staticClass: "ushk-container"
  }, [_c('div', {
    staticClass: "ushk-box"
  }, [_c('ushk-header'), _vm._v(" "), _c('div', {
    staticClass: "ushk-page"
  }, [_c('div', {
    staticClass: "ushk-wrap ushk-wrap-main"
  }, [_c('home')], 1)])], 1), _vm._v(" "), _c('ushk-footer')], 1), _vm._v(" "), _c('backtop')], 1)
},staticRenderFns: []}

/***/ }),

/***/ "hEtx":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("G/u4"),
  /* template */
  __webpack_require__("PZPv"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "mQei":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("R3P1"),
  /* template */
  __webpack_require__("GoUn"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showLogin", function() { return showLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons__ = __webpack_require__("N4+L");






var getUser = function getUser(_ref) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_fetch__["a" /* fetch */])({
      type: 'jsonp',
      url: __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].ucenterInfo,
      showError: false,
      success: function success(response) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], response.data);
        resolve(response);
      },
      fail: function fail(response) {
        reject(response);
      }
    });
  });
};

var isShowLogin = false;
var showLogin = function showLogin(_ref2, type) {
  var commit = _ref2.commit;

  if (isShowLogin) {
    return false;
  }
  isShowLogin = true;
  setTimeout(function () {
    isShowLogin = false;
  }, 1000);
  type = type || 'login';
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons__["a" /* showLoginBox */])({
      embedded: type === 'embedded',
      loginCallback: function loginCallback(datas) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], datas.data);
        resolve();
      },
      oauthCallback: function oauthCallback() {
        getUser({ commit: commit }).then(function () {
          resolve();
        });
      },

      type: type === 'embedded' ? 'login' : type
    });
  });
};

/***/ }),

/***/ "meVE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAJCAYAAACCPip6AAACKElEQVRIS7WUOWhUURSGvz/BJBPFrXEBGwsrJYKp1IjBJZB5TwOGaUxpq1HEKG6FG2ogGG0ttRkiRGcmEBciiVpFUExlYSO4NG7oTKJkjsxjMk5u5g1T+F737rk/5+M/57/C+SxNR+FIHqNuLezfkiyhmVPyOFurpnDP0lwiy1Ul+Fmr7n/zqbyxJaknxuvgLEeLEszWAmYpLgCnqaNVcV7VpMmwmTyTwBX5nK9JEwFfyQBL0kCMXuB6EaaPHINK8LsanKVoAV4AzYgx4IA8vlbVpFkB3MNoB7LAVvlF40OEUfHJUnQjTmJsAhqd/jOINxjX5DM0V7Nh1lHPbaAVWOmmCPEOI4PHUQkL1t0QaW4g4hjrCylzdF+ASWY5pC7el3pFzWdjNPGLUYwdFc0X4yymQ+1Mz4tLihNl2+JKvwE73akWt+UpsDxk0H3y6Z/XJ2K+YAr2iGVM8wzY6IBN0cR27eF7JWBLM4BxzKn9QeySx0SIpg3jCbDIqQ/I53hFTYR8/96AFHeAgw7AXfn0hOXZMuwnz/CC2HjE5lbf1RajkFsQtzq6FOd+aK+I+MoNGAfaEB8DCGMNMCE/JBqFKw84jLgJwUP5trRBMVZrN58rTvMxq8jxqVibAjYADRhHtI9bVQyIhK/cgBHEENlgEwpveg9Gt3w6Q6HSnMFYSiOD2ssHG2Eb+eBtuCiPlyER2AKco45+dfLcHrKWGXoRP+RxuYoBkfD9BQrgCBjbYCnMAAAAAElFTkSuQmCC"

/***/ }),

/***/ "mfWr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-04@2x.c82f55c.png";

/***/ }),

/***/ "mw7i":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/data-empty.85ceb63.png";

/***/ }),

/***/ "nLeL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notice-icon.08699b5.png";

/***/ }),

/***/ "pIJq":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('jin-popover', {
    attrs: {
      "placement": "bottom-start",
      "open-delay": 300,
      "popper-class": "ushk-company-popover",
      "trigger": "click",
      "transition": "zoom-in-bottom",
      "popper-options": _vm.popperOptions,
      "is-remove-slot": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "ushk-company"
  }, [(_vm.datas.length) ? _vm._l((_vm.datas), function(data) {
    return (_vm.datas.length) ? _c('ushk-message', {
      key: data.id,
      attrs: {
        "data": data,
        "is-show-company-list": false
      }
    }) : _vm._e()
  }) : _c('div', {
    staticClass: "ushk-company_none"
  }, [_vm._v("暂无数杮")])], 2), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "pNk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    function documentHandler(e) {
      if (el.contains(e.target)) {
        return false;
      }
      if (binding.expression) {
        binding.value(e);
      }
    }
    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  update: function update() {},
  unbind: function unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
});

/***/ }),

/***/ "pZ43":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/star-important@2x.1d63e1a.png";

/***/ }),

/***/ "paCF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-01.464a094.png";

/***/ }),

/***/ "poFz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/remark-image-text.770ea7e.png";

/***/ }),

/***/ "qLZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");





var state = {

  list: [],
  isListEnd: false,
  orgList: []
};

var getters = {
  list: function list(state) {
    return state.list;
  },
  isListEnd: function isListEnd(state) {
    return state.isListEnd;
  }
};

var actions = {
  getList: function getList(_ref, _ref2) {
    var commit = _ref.commit;
    var page = _ref2.page,
        type = _ref2.type,
        onCompleted = _ref2.onCompleted;


    var me = this;

    if (page == 1) {

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        var url = __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].video.list(page, type);

        window['JQ_3c42cf2edf105ad172a61c9eef7097cc'] = window['JQ_8dfb823cd98999b77e04d61deabdb4e4'] = window["JQ_2f906963abfa705c491a32911aa449ff"] = window['JQ_8a2783ae91350e5b3078ee73418dcf1e'] = function (data) {
          data.map(function (item) {

            item.isHover = false;
            item.isPlayer = false;
            item.lazyImage = "//cdn.jin10.com/assets/img/sites/video/lazy-bg.png";
            item.isShow = false;
            item.imgUrl2 = __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].video.getEffect(item.id);
            item.isPause = true;
            item.isReset = false;
            item.isShowDesc = true;
            item.scrollTop = 0;
          });
          me.state.orgList = data;

          commit('getList', {
            data: data,
            page: page,
            onCompleted: onCompleted
          });

          resolve(data);
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["a" /* addScript */])(url, function (argument) {});
      });
    } else {
      commit('getList', {
        data: me.state.orgList,
        page: page,
        onCompleted: onCompleted
      });
    }
  }
};

var pageSize = 10;

var mutations = {
  getList: function getList(state, _ref3) {
    var data = _ref3.data,
        page = _ref3.page,
        onCompleted = _ref3.onCompleted;

    state.orgList = data;
    var newData = state.orgList.concat([]);

    if (page * pageSize >= state.orgList.length) {

      state.list = state.orgList;
      state.isListEnd = true;
    } else {
      newData.length = page * pageSize;
      state.list = newData;
      state.isListEnd = false;
    }

    if (onCompleted) {

      onCompleted(data);
    }
  },
  isItemShow: function isItemShow(state, index) {

    return state.list[index].isShow;
  },
  setItemShow: function setItemShow(state, index) {

    if (!state.list[index].isShow) {
      state.list[index].isShow = true;
    }
  },
  setItemScrollTop: function setItemScrollTop(state, _ref4) {
    var index = _ref4.index,
        scrollTop = _ref4.scrollTop;

    state.list[index].scrollTop = scrollTop;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "qNF3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arrow.f3906ca.png";

/***/ }),

/***/ "qNZ7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certification.1c5d039.png";

/***/ }),

/***/ "qOm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter__ = __webpack_require__("8ttZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");






/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: {
    name: String
  },
  data: function data() {
    return {
      visible: false,
      isLoading: true,
      datas: [],
      popperOptions: {
        gpuAcceleration: false,
        removeOnDestroy: true
      }
    };
  },

  watch: {
    visible: function visible(v, ov) {
      if (v) {
        this.render();
      }
    }
  },
  beforeCreate: function beforeCreate() {
    this.$options.components.UshkMessage = __webpack_require__("Juq6");
  },

  methods: {
    render: function render() {
      var _this = this;

      this.getList().then(function (datas) {
        _this.datas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__filter__["b" /* dataSplicing */])(datas);
      });
    },
    getList: function getList() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.isLoading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_fetch__["a" /* fetch */])({
          url: __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].home.company,
          params: {
            keyword: _this2.name,
            max_time: 0
          },
          type: 'jsonp',
          jsonpCallback: 'callback',
          callback: function callback(res) {
            _this2.isLoading = false;
          },
          success: function success(res) {
            resolve(res.data);
          },
          error: function error() {
            _this2.isLoading = false;
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "sK0k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tencent.87f621f.png";

/***/ }),

/***/ "u8M6":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  null,
  /* template */
  __webpack_require__("Ew40"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "uEbN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-02.846fdce.png";

/***/ }),

/***/ "ufEw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-4.550c545.png";

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _types$UPDATE_USER$se;


/* harmony default export */ __webpack_exports__["a"] = (_types$UPDATE_USER$se = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], function (state, datas) {
  state.user = datas;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, 'setVideoState', function setVideoState(state, isVideoPlaying) {

  state.isVideoPlaying = isVideoPlaying;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, 'setVideoType', function setVideoType(state, type) {

  state.videoType = type;
}), _types$UPDATE_USER$se);

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v2os":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-rate.b04d01b.png";

/***/ }),

/***/ "v571":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/time-weekly@2x.23ab82b.png";

/***/ }),

/***/ "vTv7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-03.8a91071.png";

/***/ }),

/***/ "vm9q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bullish.90f2627.png";

/***/ }),

/***/ "wTUH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/renzhenglianmeng@2x.828f805.png";

/***/ }),

/***/ "wz0z":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-flash"
  }, [(!_vm.datas.length) ? _c('skeleton') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_list",
    attrs: {
      "id": "J_flash_list"
    }
  }, [(_vm.datas.length) ? _c('ushk-message-group', {
    attrs: {
      "datas": _vm.renderDatas
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ushk-more"
  }, [(_vm.datas.length) ? _c('a', {
    staticClass: "ushk-more__btn",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.lower
    }
  }, [_c('i', {
    staticClass: "ushk-icon ushk-icon_expand"
  }), _vm._v("点击加载更多")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "x58Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_utils__ = __webpack_require__("j+bc");


function push() {
  var w = window;
  var hasPermission = false,
      notifications = {},
      currentId = 0,
      isSupported = function () {
    var isSupported = false;
    try {
      isSupported = !!(w.Notification || w.webkitNotifications || navigator.mozNotification || w.external && w.external.msIsSiteMode() !== undefined);
    } catch (e) {}

    return isSupported;
  }(),
      closeNotification = function closeNotification(id) {
    var errored = false,
        notification = notifications[id];
    if (typeof notification !== 'undefined') {
      if (notification.close) {
        notification.close();
      } else if (notification.cancel) {
          notification.cancel();
        } else if (w.external && w.external.msIsSiteMode) {
            w.external.msSiteModeClearIconOverlay();
          } else {
            errored = true;
            alert('');
          }
      if (!errored) {
        return removeNotification(id);
      }
    }
    return false;
  },
      addNotification = function addNotification(notification) {
    var id = currentId;
    notifications[id] = notification;
    currentId++;
    return id;
  },
      removeNotification = function removeNotification(id) {
    var dict = {},
        success = false;
    for (var key in notifications) {
      if (notifications.hasOwnProperty(key)) {
        if (key != id) {
          dict[key] = notifications[key];
        } else {
          success = true;
        }
      }
    }
    notifications = dict;
    return success;
  },
      createCallback = function createCallback(title, options) {
    var notification = void 0,
        wrapper = void 0,
        id = void 0,
        onClose = void 0;
    options = options || {};

    if (w.Notification) {
      notification = new w.Notification(title, {
        icon: options.icon || '',
        body: options.body,
        tag: options.tag,
        requireInteraction: options.requireInteraction
      });
    } else if (w.webkitNotifications) {
        notification = w.webkitNotifications.createNotification(options.icon, title, options.body);
        notification.show();
      } else if (navigator.mozNotification) {
          notification = navigator.mozNotification.createNotification(title, options.body, options.icon);
          notification.show();
        } else if (w.external && w.external.msIsSiteMode()) {
            w.external.msSiteModeClearIconOverlay();
            w.external.msSiteModeSetIconOverlay(isString(options.icon) || isUndefined(options.icon) ? options.icon : options.icon.x16, title);
            w.external.msSiteModeActivate();
            notification = {};
          } else {
            throw new Error('Unable to create notification: unknown interface');
          }

    id = addNotification(notification);

    wrapper = {
      get: function get() {
        return notification;
      },

      close: function close() {
        closeNotification(id);
      }
    };

    if (options.timeout) {
      setTimeout(function () {
        wrapper.close();
      }, options.timeout);
    }

    if (typeof options.onShow === 'function') {
      notification.addEventListener('show', options.onShow);
    }
    if (typeof options.onError === 'function') {
      notification.addEventListener('error', options.onError);
    }
    if (typeof options.onClick === 'function') {
      notification.addEventListener('click', options.onClick);
    }

    onClose = function onClose() {
      removeNotification(id);
      if (typeof options.onClose !== 'undefined') {
        options.onClose.call(this);
      }
    };

    notification.addEventListener('close', onClose);
    notification.addEventListener('cancel', onClose);

    return wrapper;
  },
      Permission = {
    DEFAULT: 'default',
    GRANTED: 'granted',
    DENIED: 'denied',

    request: function request(onGranted, onDenied) {
      if (!isSupported) {
        return false;
      }
      var self = this,
          callback = function callback(result) {
        switch (result) {
          case self.GRANTED:
            hasPermission = true;
            if (onGranted) onGranted();
            break;

          case self.DENIED:
            hasPermission = false;
            if (onDenied) onDenied();
            break;
        }
      };

      if (w.Notification && w.Notification.requestPermission) {
        Notification.requestPermission(callback);
      } else if (w.webkitNotifications && w.webkitNotifications.checkPermission) {
          w.webkitNotifications.requestPermission(callback);
        }
    },

    has: function has() {
      return hasPermission;
    },

    get: function get() {
      var permission = void 0;

      if (!isSupported) {
        return false;
      }

      if (w.Notification && w.Notification.permissionLevel) {
        permission = w.Notification.permissionLevel;
      } else if (w.webkitNotifications && w.webkitNotifications.checkPermission) {
        permission = Permissions[w.webkitNotifications.checkPermission()];
      } else if (w.Notification && w.Notification.permission) {
        permission = w.Notification.permission;
      } else if (navigator.mozNotification) {
        permission = Permissions.GRANTED;
      } else if (w.external && w.external.msIsSiteMode() !== undefined) {
        permission = w.external.msIsSiteMode() ? Permission.GRANTED : Permission.DEFAULT;
      } else {
        return false;
      }

      return permission;
    }

  },
      Permissions = [Permission.GRANTED, Permission.DEFAULT, Permission.DENIED];

  return {
    notifications: notifications,
    Permission: Permission,
    isSupported: isSupported,
    createCallback: createCallback,
    closeNotification: closeNotification,
    addNotification: addNotification,
    removeNotification: removeNotification
  };
}
var flashPush = push();
var cookieName = 'notification';
var flashNotification = {
  isDenied: function isDenied() {
    return flashPush.Permission.get() === flashPush.Permission.DENIED;
  },
  isGranted: function isGranted() {
    return flashPush.Permission.get() === flashPush.Permission.GRANTED;
  },
  getState: function getState() {
    return __WEBPACK_IMPORTED_MODULE_0__commons_utils__["h" /* cookie */].get(cookieName);
  },
  close: function close() {
    __WEBPACK_IMPORTED_MODULE_0__commons_utils__["h" /* cookie */].set(cookieName, 'close');
  },
  open: function open() {
    __WEBPACK_IMPORTED_MODULE_0__commons_utils__["h" /* cookie */].set(cookieName, 'open');
  },
  request: function request(callback) {
    if (!this.isGranted()) {
      flashPush.Permission.request(callback);
    }
  },
  create: function create(title, options) {
    var _this = this;

    if (!flashPush.isSupported || this.getState(cookieName) == 'close') {
      return false;
    }
    if (!flashPush.Permission.has()) {
      flashPush.Permission.request(function () {
        _this.open();
        flashPush.createCallback(title, options);
      });
    } else {
      flashPush.createCallback(title, options);
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (flashNotification);

/***/ }),

/***/ "xQAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");


var state = {};

var getters = {};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "zKOH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic-02@2x.9481d8f.png";

/***/ }),

/***/ "zfj7":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about/head-pic-01.png": "M3LB",
	"./about/head-pic-01@2x.png": "DO2A",
	"./about/head-pic.png": "IHS+",
	"./about/head-pic@2x.png": "47nT",
	"./about/m/head-pic.png": "ekTD",
	"./about/m/head-pic@2x.png": "eGjY",
	"./about/m/pic-01.png": "paCF",
	"./about/m/pic-01@2x.png": "LW1D",
	"./about/m/pic-02.png": "Z3oC",
	"./about/m/pic-02@2x.png": "awGH",
	"./about/m/pic-03.png": "vTv7",
	"./about/m/pic-03@2x.png": "DgEf",
	"./about/m/pic-04.png": "BgiE",
	"./about/m/pic-04@2x.png": "mfWr",
	"./about/pic-01.png": "5+GW",
	"./about/pic-01@2x.png": "AaAd",
	"./about/pic-02.png": "uEbN",
	"./about/pic-02@2x.png": "zKOH",
	"./about/pic-03.png": "RTXE",
	"./about/pic-03@2x.png": "3SEp",
	"./about/pic-04.png": "WrAD",
	"./about/pic-04@2x.png": "dWG8",
	"./arrow.png": "qNF3",
	"./bearish.png": "dgx8",
	"./bullish.png": "vm9q",
	"./commons/data-empty.png": "mw7i",
	"./commons/footer/certification.png": "qNZ7",
	"./commons/footer/certification@2x.png": "0+am",
	"./commons/footer/chengxinwangzhan.png": "1/Qc",
	"./commons/footer/chengxinwangzhan@2x.png": "ahqO",
	"./commons/footer/kexinwangzhan.png": "Uq1x",
	"./commons/footer/kexinwangzhan@2x.png": "gBM3",
	"./commons/footer/renzhenglianmeng.png": "feRo",
	"./commons/footer/renzhenglianmeng@2x.png": "wTUH",
	"./commons/footer/tencent.png": "sK0k",
	"./commons/footer/tencent@2x.png": "UxDv",
	"./commons/footer/time-weekly.png": "4AC6",
	"./commons/footer/time-weekly@2x.png": "v571",
	"./commons/footer/zhongjin.png": "zjmM",
	"./commons/footer/zhongjin@2x.png": "QqS3",
	"./commons/header/logo.png": "7+0T",
	"./commons/header/logo@2x.png": "Z2Ax",
	"./commons/money-active.png": "DS8b",
	"./commons/money-active@2x.png": "ZaBU",
	"./commons/money-important.png": "ck8E",
	"./commons/money-important@2x.png": "Axr/",
	"./commons/money.png": "9hpj",
	"./commons/money@2x.png": "StUP",
	"./commons/star-active.png": "meVE",
	"./commons/star-active@2x.png": "BEao",
	"./commons/star-important.png": "NSa5",
	"./commons/star-important@2x.png": "pZ43",
	"./commons/star.png": "NA1v",
	"./commons/star@2x.png": "GBdf",
	"./icon-1.png": "4R6w",
	"./icon-2.png": "ZQHk",
	"./icon-3.png": "9eTL",
	"./icon-4.png": "ufEw",
	"./icon-calendar.png": "WfM0",
	"./icon-rate.png": "v2os",
	"./icon-sm.png": "VwCb",
	"./notice-icon-2.png": "HKpY",
	"./notice-icon.png": "nLeL",
	"./remark-content.png": "Ycs1",
	"./remark-data.png": "eANS",
	"./remark-image-text.png": "poFz",
	"./remark-link.png": "ZY5R",
	"./remark-market.png": "+yxU",
	"./remark-video.png": "dpXS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zfj7";

/***/ }),

/***/ "zjmM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhongjin.4c61c3c.png";

/***/ })

},[4]);


// WEBPACK FOOTER //
// static/js/index.de7edeb9937dd416dd9c.js